// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tabletMiddle":"(max-width: 768px)","loyalty__modal":"loyalty__modal-3JBea","switchWrapper":"switchWrapper-3MslX"};